import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { formatPrice, removeVietnameseTones } from "../../../../services/helpers/Helper";
import { fetchProducts } from "../../../../store/action/productAction";
import Modal from "../../../shared/components/modal";
const _ = require('lodash');

const FormProductList = (props) => {
   const { onClose, fetchProducts, products, handleSelectedProductWarehouse } = props;
   const params = useParams();
   const { id } = params;
   const [search, setSearch] = useState('');
   const [listSelected, setListSelected] = useState([]);

   useEffect(() => {
      fetchProducts(id);
   }, [id]);

   const getData = () => {
      let data = [];
      if (products && products.length > 0) {
         data = products.filter((f) => {
            if (!!search) {
               return removeVietnameseTones(f.name.toLowerCase()).includes(removeVietnameseTones(search.toLowerCase()));
            }
            return true;
         });

      }
      return data;
   }

   const handleSelected = (e, item) => {
      if (item.is_used) {
         return;
      }
      setListSelected(oldArray => {
         if (e.target.checked) {
            return [...oldArray, item.id];
         } else {
            return oldArray.filter((f) => f !== item.id);
         }
      });
   }


   const handleSelect = () => {
      const data = products.filter((f) => _.includes(listSelected, f.id)).map((m) => ({ ...m, product_unit: m.quantity_available }));
      handleSelectedProductWarehouse(data);
   }

   return (
      <Modal>
         <div className="modal-dialog app-modal app-v2-modal popup-choose-products-livestream-wrapper modal-lg" role="document">
            <div className="modal-content">
               <div className="app-modal-header">
                  <h4 className="app-modal-title">
                     <div className="app-v2-modal-header">
                        <div className="custom">Chọn sản phẩm từ Warehouse</div>
                        <div className="icon-wrapper"><span className="icon-close app-close">
                           <div className="svg-next-icon ic-modal-close" onClick={onClose}>
                           </div>
                        </span></div>
                     </div>
                  </h4>
               </div>
               <div className="app-modal-body">
                  <div className="fix">
                     <div className="app-modal--body-section">
                        <div className="popup-choose-products-body-wrapper app-modal-multiple-select-product">
                           <div className="popup-choose-products-body-filter-wrapper">
                              <div className="display-flex border-radius4 input-with-icon">
                                 <div className="left-icon">
                                    <div className="svg-next-icon ic-search-2">
                                    </div>
                                 </div>
                                 <div className="input-container">
                                    <input type="text" placeholder="Tìm sản phẩm" value={search} onChange={(e) => setSearch(e.target.value)} />
                                 </div>
                              </div>
                              {/* <div className="app-select app-select-enabled">
                                 <div className="app-select-selection app-select-selection--single" role="combobox" tabIndex="0">
                                    <div className="app-select-selection__rendered">
                                       <div className="app-select-selection-selected-value" title="Tất cả" style={{ display: "block", opacity: 1 }}>Tất cả</div>
                                    </div>
                                    <span className="app-select-arrow" unselectable="on" style={{ userSelect: "none" }}>
                                       <svg className="app-svg-inline-block app-svg-next-icon-rotate-90 app-select-arrow-icon" width="16px" height="16px" viewBox="0 0 16 16">
                                          <path d="M6.47 4L5.53 4.94L8.58333 8L5.53 11.06L6.47 12L10.47 8L6.47 4Z"></path>
                                       </svg>
                                    </span>
                                 </div>
                              </div> */}
                           </div>
                           <div className="app-product-selector__list--container app-scrollbar transition-delay-appear">
                              <div className="app-product-selector__list">
                                 {getData().map((item, index) => {
                                    return (
                                       <label style={{ marginBottom: 0, width: '100%' }} key={index} htmlFor={`checked-${index}`}>
                                          <div className="app-product-selector-group-item-wrapper transition-delay-appear " >
                                             <div className="app-product-selector-group-item-box cursor-pointer">
                                                <div className="app-product-selector-item-box-container app-product-selector-item-product-parent ">
                                                   <div className="app-product-selector-item-box-wrapper">
                                                      <div className="image-container">

                                                         <div className="app-next-input-checkbox hrs-input-checkbox">
                                                            {!item.is_used &&
                                                               <React.Fragment>
                                                                  <label className="app-next-label--switch app-next-label--empty" >
                                                                  </label>
                                                                  <input
                                                                     type="checkbox"
                                                                     className="app-next-checkbox"
                                                                     id={`checked-${index}`}
                                                                     checked={_.includes(listSelected, item.id)}
                                                                     onChange={(e) => handleSelected(e, item)}
                                                                  />
                                                                  <span className="app-next-checkbox--styled">
                                                                     <span className="app-svg-next-icon app-checkmark" style={{ top: 1, left: 1 }}>
                                                                        <svg className="app-svg-inline-block" width="10px" height="10px" viewBox="0 0 26 26">
                                                                           <path d="m.3,14c-0.2-0.2-0.3-0.5-0.3-0.7s0.1-0.5 0.3-0.7l1.4-1.4c0.4-0.4 1-0.4 1.4,0l.1,.1 5.5,5.9c0.2,0.2 0.5,0.2 0.7,0l13.4-13.9h0.1v-8.88178e-16c0.4-0.4 1-0.4 1.4,0l1.4,1.4c0.4,0.4 0.4,1 0,1.4l0,0-16,16.6c-0.2,0.2-0.4,0.3-0.7,0.3-0.3,0-0.5-0.1-0.7-0.3l-7.8-8.4-.2-.3z">
                                                                           </path>
                                                                        </svg>
                                                                     </span>
                                                                  </span>
                                                               </React.Fragment>
                                                            }
                                                         </div>
                                                         <div className="app-product-selector__item--image">
                                                            {item.product_image ?
                                                               <img src={item.product_image} />
                                                               :
                                                               <svg width="40" height="40" fill="none" viewBox="0 0 60 60">
                                                                  <rect width="60" height="60" fill="#BAC8D3" rx="3"></rect> <path fill="#fff" d="M11.462 37.19l6.753-9.271a1.252 1.252 0 011.802-.194l5.128 4.442c.247.213.577.318.91.292.334-.026.64-.181.847-.429l8.934-9.916c.232-.279.59-.439.967-.432.377.006.73.178.95.465l9.934 15.019c.266.344.304.798.098 1.177-.205.378-.62.616-1.072.615H12.45c-.446 0-.856-.232-1.063-.603-.208-.371-.18-.82.074-1.165zm13.502-10.94c-1.653 0-2.993-1.26-2.993-2.813 0-1.553 1.34-2.812 2.993-2.812 1.653 0 2.993 1.259 2.993 2.812s-1.34 2.812-2.993 2.812z">
                                                                  </path>
                                                               </svg>
                                                            }
                                                         </div>
                                                      </div>
                                                      <div className="app-product-selector__item--info" style={{ justifyContent: 'space-between' }}>
                                                         <div className="app-product-selector__item--name" style={{ width: "60%" }}>
                                                            <span title={item.name}>
                                                               {item.name}
                                                            </span>
                                                         </div>
                                                         <div className="app-product-selector__item--inventory" style={{ width: "20%", textAlign: 'right' }}>{formatPrice(item.quantity_available)} Tồn kho</div>
                                                         <div className="app-product-selector__item--price" style={{ width: "20%", textAlign: 'right' }}>{formatPrice(item.product_price)} ₫</div>

                                                      </div>
                                                   </div>
                                                </div>
                                             </div>
                                          </div>
                                       </label>
                                    )
                                 })}
                              </div>
                           </div>
                        </div>
                     </div>
                     <div className="app-modal-footer-wrapper"><span className="app-modal-footer-product-selected">
                        {listSelected.length} sản phẩm đã được chọn
                     </span>
                        <div className="app-modal-footer-actions-wrapper">
                           <button type="button" className="app-btn app-btn-default" onClick={onClose}>
                              Hủy
                           </button>
                           <button disabled={!listSelected.length} type="button" className="app-btn app-btn-primary app-modal--button ml15" onClick={handleSelect}>
                              <span>
                                 Hoàn tất chọn
                              </span>
                           </button>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="app-modal-footer">
                  <div className="col-auto"></div>
               </div>
            </div>
         </div>
      </Modal>
   )
}

const mapStateToProps = (state) => {
   const { products } = state;
   return {
      products
   };
};


export default connect(mapStateToProps, {
   fetchProducts
})(FormProductList)

